export default __webpack_public_path__ + "static/media/tutorial01.c46273a7.jpg";